import { Header } from '@/components/Layout/Header/Header';
import { DetailsGrantList } from '@/components/Views/Finance/DetailsGrantList';

export const DetailsGrant = () => {
  return (
    <div className="flex flex-col max-h-screen">
      <Header
        title="Détails de subventions"
        userName="Mas Aly"
        role="Admin"
        goBack
      />
      <DetailsGrantList />
    </div>
  );
};
